import { Link } from 'react-router-dom';
import { LegalDocument } from '../components/LegalDocument';
// Vite's `?raw` suffix imports the file's text content as a plain string at
// build time — docs/legal/privacy-policy.md stays the ONE source of truth
// (16 [PRODUCT] placeholders and all), rendered here rather than forked into
// a JSX copy. Same reach pattern as Terms.tsx's eulaMarkdown import.
import privacyMarkdown from '../../../../docs/legal/privacy-policy.md?raw';
import styles from './Settings.module.css';

/**
 * /privacy — renders docs/legal/privacy-policy.md in-app. Linked from
 * SignIn, Settings, and the enrollment consent step (ConsentGate.tsx).
 */
export function Privacy() {
  return (
    <div className={styles.page}>
      <Link to="/" className={styles.backButton}>
        <svg width="9" height="16" viewBox="0 0 9 16" fill="none" aria-hidden="true">
          <path
            d="M8 1L2 8l6 7"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Home
      </Link>
      <LegalDocument markdown={privacyMarkdown} />
    </div>
  );
}
